<script setup lang="ts">
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import PageHeader from "@/components/menu/PageHeader.vue";
import IterationItem from "@/components/search/dropdown/IterationItem.vue";
import StickyTypeItem from "@/components/search/dropdown/StickyTypeItem.vue";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import ToggleButton from "@/components/ui/ToggleButton/ToggleButton.vue";
import { useActivityStore } from "@/store/activity";

import DateFilter from "./internal/DateFilter.vue";

function close() {
  useActivityStore().inactivate();
}

const store = useActivityStore();
</script>

<template>
  <PageHeader :title="$t('boardDiff.boardTitle')" icon="general/board-history" @close="close">
    <ToggleButton
      class="mode-toggle"
      :active="store.tab === 'log' ? 'left' : 'right'"
      @click="store.toggleTab()"
    >
      <template #left>{{ $t("boardDiff.log.title") }}</template>
      <template #right>{{ $t("boardDiff.compare.title") }}</template>
    </ToggleButton>
    <MenuItemDelimiter />
    <div>
      <BaseTooltip :content="$t('boardDiff.dateRange')">
        <DateFilter v-model="store.selectedDate" :values="store.dateFilterOptions" />
      </BaseTooltip>
    </div>
    <MenuItemDelimiter />
    <!-- Filters (sticky type, iteration) -->
    <div>
      <StickyTypeItem :store />
      <IterationItem :store />
    </div>
  </PageHeader>
</template>
